module.exports = __webpack_public_path__ + "static/2-5702779be934f2a3267554b5f148f06e.png";